import type {CopilotCliCommand} from '../CopilotCliPicker'
import type {DetailsTemplateSettings} from '../../../types'

export function getExperimentCommands(settings?: DetailsTemplateSettings): CopilotCliCommand[] {
  const commands = settings?.fields.experiments?.cliCommands

  if (!Array.isArray(commands)) return []

  return commands.flatMap(command => {
    if (!isExperimentCommand(command)) return []

    const title = command.title.trim()
    const commandText = command.command.trim()

    if (!title || !commandText) return []

    return [{title, command: commandText}]
  })
}

function isExperimentCommand(command: unknown): command is CopilotCliCommand {
  if (!command || typeof command !== 'object') return false

  return (
    'title' in command &&
    typeof command.title === 'string' &&
    'command' in command &&
    typeof command.command === 'string'
  )
}
